<script setup lang="ts">
import { computed } from 'vue'

import type { RecipeParagraph } from '../../../utils/paragraph-schema/paragraphs'

const props = defineProps<{
  cookingTime?: RecipeParagraph['recipe']['cookingTime'],
  difficulty?: string
}>()

const cookingTimeTotal = computed(() => (props.cookingTime?.preparation || 0) + (props.cookingTime?.cooking || 0))
</script>

<template>
  <ul class="bx-recipe__preparation bx-content__continuous-text bx-typo--content-continuous-text">
    <li>
      <div>Zubereitungszeit:</div>
      <div><strong>{{ cookingTimeTotal }} Min.</strong></div>
    </li>
    <li v-if="cookingTime?.idle">
      <div>Wartezeit:</div>
      <div><strong>{{ cookingTime.idle }} Min.</strong></div>
    </li>
    <li v-if="difficulty">
      <div>Niveau:</div>
      <div><strong>{{ difficulty }}</strong></div>
    </li>
  </ul>
</template>
